export enum Brand {
  Lufthansa = 'lufthansa',
  Austrian = 'austrian',
  Swiss = 'swiss',
  Brussels = 'brussels',
  Discover = 'discover',
}

export enum BrandId {
  Lufthansa = 'LH',
  Austrian = 'OS',
  Swiss = 'LX',
  Brussels = 'SN',
  Discover = '4Y',
}

interface BrandInfo {
  id: BrandId;
  brandTitle: string;
  prettyDomain: string;
  shortDomain: string;
  supportContact: string; // literal string or language file key
}

const brandInfo: { [index: string]: BrandInfo } = {
  [Brand.Lufthansa]: {
    id: BrandId.Lufthansa,
    brandTitle: 'Lufthansa',
    prettyDomain: 'Lufthansa.com',
    shortDomain: 'lh.com',
    supportContact: 'common.service_center',
  },
  [Brand.Austrian]: {
    id: BrandId.Austrian,
    brandTitle: 'Austrian',
    prettyDomain: 'Austrian.com',
    shortDomain: 'Austrian.com',
    supportContact: '<a href="mailto:austrian.voucher@austrian.com">austrian.voucher@austrian.com</a>',
  },
  [Brand.Swiss]: {
    id: BrandId.Swiss,
    brandTitle: 'Swiss',
    prettyDomain: 'Swiss.com',
    shortDomain: 'Swiss.com',
    supportContact: '<a href="mailto:voucher.support@swiss.com">voucher.support@swiss.com</a>',
  },
  [Brand.Brussels]: {
    id: BrandId.Brussels,
    brandTitle: 'BrusselsAirlines',
    prettyDomain: 'BrusselsAirlines.com',
    shortDomain: 'BrusselsAirlines.com',
    supportContact: 'common.service_center',
  },
  [Brand.Discover]: {
    id: BrandId.Discover,
    brandTitle: 'DiscoverAirlines',
    prettyDomain: 'discover-airlines.com',
    shortDomain: 'discover-airlines.com',
    supportContact: 'common.service_center',
  },
}

let activeBrand: Brand | undefined

export const setBrand = (brandName: Brand): void => {
  activeBrand = brandName
}

export const getBrand = (): Brand | undefined => activeBrand

export const getBrandInfo = (): BrandInfo => {
  if (!activeBrand) return brandInfo[Brand.Lufthansa]
  return brandInfo[activeBrand]
}

export const brandPlugin = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  install(Vue: any, options: any): void {
    const brandInfo = getBrandInfo()

    if (options.i18n.te(brandInfo.supportContact)) {
      brandInfo.supportContact = options.i18n.t(brandInfo.supportContact)
    }

    Vue.brandInfo = brandInfo
    Vue.prototype.brandInfo = brandInfo

    Vue.Brand = Brand
    Vue.prototype.Brand = Brand
  },
}
